let fadeElements = document.querySelectorAll(".fade-in");
window.addEventListener('scroll', fadeIn);
function fadeIn() {
    for (var i = 0; i < fadeElements.length; i++) {
        var elem = fadeElements[i]
        var distInView = elem.getBoundingClientRect().top - window.innerHeight;
        if (distInView < 0) {
            elem.classList.add("in-view");
        } else {
            elem.classList.remove("in-view");
        }
    }
}
fadeIn();